import { CameraControls, CameraControlsProps } from '@react-three/drei';
import { HoleCameraControls } from './HoleCameraControls';
import * as THREE from 'three';
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { isHoleCameraControls } from './isHoleCameraControls';
import { useGesture } from '@use-gesture/react';
import { useThree } from '@react-three/fiber';

type HoleControlsProps = CameraControlsProps & {
  curve: THREE.CatmullRomCurve3;
  tracker: THREE.CatmullRomCurve3;
  enableRotation?: boolean;
  enableTravelling?: boolean;
  orbital?: boolean;
};

export const HoleControls = forwardRef<HoleCameraControls, HoleControlsProps>(
  ({ curve, tracker, orbital, ...restProps }, fowardefRef) => {
    const cameraControlsRef = useRef<HoleCameraControls>(null);

    const events = useThree(({ events }) => events);

    useEffect(() => {
      cameraControlsRef.current?.init(curve, tracker);
    }, [curve, tracker]);

    useGesture(
      {
        onDrag: ({ delta: [dx, dy], down, first, last, cancel, timeDelta }) => {
          const controls = cameraControlsRef.current;
          if (!isHoleCameraControls(controls) || !controls.enabled) return;
          if (orbital) {
            controls.connect(events.connected);
            return;
          }
          controls.onDrag(dx, dy, down, first, last, timeDelta, cancel);
        },
      },
      { target: events.connected, eventOptions: { passive: false } },
    );

    useImperativeHandle(fowardefRef, () => {
      return cameraControlsRef.current!;
    }, []);

    // Move this logic on top

    /* const storeSet = useStore(({ set }) => set); */

    /* useEffect(() => {
      storeSet({ controls: controls as any });
    }, []); */

    return <CameraControls ref={cameraControlsRef} impl={HoleCameraControls} {...restProps} />;
  },
);

export { HoleCameraControls };
